var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:({
    exclude: ['dropdown-custom'],
    handler: 'hide'
  }),expression:"{\n    exclude: ['dropdown-custom'],\n    handler: 'hide'\n  }"}],ref:"dropdown-custom",staticClass:"dropdown-custom",class:[
    _vm.visible && 'dropdown-custom--active',
    _vm.className
  ]},[_c('div',{staticClass:"dropdown-custom__title",on:{"click":function($event){return _vm.open()}}},[_vm._t("dropdown-custom-title")],2),_c('ul',{staticClass:"dropdown-custom__menu"},[_vm._t("dropdown-custom-menu")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }